import React from 'react';
import PropTypes from 'prop-types';

const IconOk = ({ className, width, height }) => (
    <svg
        className={`apc-svg-icon ${className}`}
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 15 15"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M13.1841667,2.60666667 L7.9725,11.3583333 C7.92583333,11.4366667 7.84333333,11.4858333 7.75,11.4858333 C7.65833333,11.4858333 7.57666667,11.4366667 7.5275,11.3583333 L6.71833333,9.99666667 C6.69916667,9.965 6.6875,9.92833333 6.68166667,9.89333333 L4.17416667,5.54666667 C4.12833333,5.4675 4.12833333,5.36833333 4.17416667,5.2875 C4.22083333,5.20833333 4.30666667,5.15833333 4.39916667,5.15833333 L6.1875,5.15833333 C6.27916667,5.15833333 6.365,5.20833333 6.41,5.28916667 L7.84666667,7.77583333 L11.6233333,1.23333333 C10.4408333,0.453333333 9.02416667,0 7.5,0 C3.35916667,0 0,3.35833333 0,7.5 C0,11.6458333 3.35916667,15 7.5,15 C11.6441667,15 15,11.6458333 15,7.5 C15,5.63 14.315,3.92 13.1841667,2.60666667"
                id="path-1"
            />
        </defs>
        <g id="Master" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="01-01-Family_ver-8" transform="translate(-930.000000, -2696.000000)">
                <g id="Key-Features" transform="translate(0.000000, 2612.000000)">
                    <g id="Icons/15px/Ok" transform="translate(930.000000, 84.000000)">
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1" />
                        </mask>
                        <g id="Fill-11" />
                        <g id="Colors-/-Life-Green" mask="url(#mask-2)" fill="#3DCD58">
                            <rect id="color" x="0" y="0" width="15" height="15" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

IconOk.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconOk.defaultProps = {
    fill: '#3DCD58',
    className: '',
    width: 15,
    height: 15,
};

export default IconOk;
